export const initHashEmail = () => {
    // Vars
    const urlQueries = window.location.search;
    const searchParams = new URLSearchParams(urlQueries);
    const email = searchParams.get('email');
    const emailFields = document.querySelectorAll('[data-email-hash]');

    // INITS
    if (email) {
        localStorage.setItem('user-email', email);
    }

    if (emailFields.length) {
        [...emailFields].forEach((emailField) => {
            emailField.value = localStorage.getItem('user-email');
        });
    }
};
